import script from "./PatientSignature.vue3.vue?vue&type=script&setup=true&lang=ts"
export * from "./PatientSignature.vue3.vue?vue&type=script&setup=true&lang=ts"

import "./PatientSignature.vue3.vue?vue&type=style&index=0&id=1507e404&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1507e404"]])

export default __exports__